import { __module as e } from "../../../_virtual/isMACAddress.js";
import { a as t } from "./util/assertString.js";
Object.defineProperty(s = e.exports, "__esModule", {
  value: !0
}), s.default = function (e, t) {
  return ((0, a.default)(e), t && (t.no_colons || t.no_separators)) ? o.test(e) : r.test(e) || f.test(e);
}, a = t && t.__esModule ? t : {
  default: t
}, r = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/, o = /^([0-9a-fA-F]){12}$/, f = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/, e.exports = s.default, e.exports.default = s.default;
var s,
  a,
  r,
  o,
  f,
  d = e.exports;
export { d as i };